import BaseSallaForm from './BaseSallaForm';

const SallaWebhookForm = () => (
	<BaseSallaForm showStatuses showCallbackUrl showBaseUrl advanceSettingsFields={['defaultWarehouse']} />
);

export default SallaWebhookForm;
